module.exports = __webpack_public_path__ + "static/img/winter_banner.82716704.jpg";